export default `#define R(th) mat2(cos(th),sin(th),-sin(th),cos(th))
float dTorus( vec3 p, float r_large, float r_small ) {
  float h = length( p.xy ) - r_large;
  float d = sqrt( h * h + p.z * p.z ) - r_small;
  return d;
}

float torusGrid( vec3 p, float r_small, float r_large, float angle, vec2 sep ) {
  
  vec3 q = p - vec3( round( p.xy / sep ) * sep, 0 ) - vec3( 0.0, sep.y / 2., 0.0 );
  q.yz *= R( angle );
  float d = dTorus( q, r_large, r_small );
  q = p - vec3( round( p.xy / sep ) * sep, 0 ) - vec3( 0.0, -sep.y / 2., 0.0 );
  q.yz *= R( angle );
  d = min( d, dTorus( q, r_large, r_small ) );
  return d;
}

float material = 0.;
float de( vec3 p ) {
  float angle = 0.3;
  vec2 sep = vec2(1.0,0.8);
  float d = torusGrid(p, 0.07, 0.4, angle, sep);
  d = min(d, torusGrid(p-vec3(sep/2.,0.0), 0.07, 0.4, -angle, sep));
  
  
  
  
  
  
  
  return d;
}`